import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import PropertyDetail from './pages/PropertyDetails';
import ProyectDetails from './pages/ProyectDetails';
import Favorites from './pages/Favorites';
import PropertySelection from './pages/PropertySelection';
import Publish from './pages/Publish';
import Terminos from './pages/TerminosCondiciones';
import Privacidad from './pages/Privacidad';
import Contacto from './pages/Contacto';
import SearchResults from './pages/SearchResults';
import Header from './components/Header';
import EditProfile from './pages/EditProfile';
import MyListings from './pages/MyListings';
import UpgradeUser from './pages/UpgradePlan';
import AllProperties from './pages/AllProperties';
import ClientRegister from './components/register/ClientRegister';
import SellerRegister from './components/register/SellerRegister';
import InmRegister from './components/register/InmRegister';
import StaffRegister from './components/StaffRegister';
import PropertyStatistics from './pages/PropertyStatistics';
import HistorialPage from './pages/Historial';
import EditPublish from './pages/EditPublish';
import EditRent from './pages/EditRent';
import EditProyect from './pages/EditProyect'; // Nuevo componente para editar proyectos
import ProfileRouter from './pages/profiles/ProfileRouter';
import CookieConsent from './components/CookieConsent';
import Statistics from './pages/StatisticsPage';
import PropertyTypePage from './pages/PropertyTypePage';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import ConsPublish from './pages/ConsPublish';
import Configuration from './pages/Configuración';
import AlquilerPage from './pages/AlquilerPage';
import AlquilerDetail from './pages/AlquilerDetail';
import UpgradeToSeller from './pages/UpgradeToSeller';
import ResetPassword from './pages/ResetPassword';
import UpgradeToInmobiliaria from './pages/UpgradeToInmobiliaria';
import FlyerPage from './pages/FlyerPage';
import InKayrosStatistics from './pages/InKayrosStatistics';
import UserTypePage from './pages/UserTypePage';
import PropertyMap from './pages/PropertyMap';
import StaffDashboard from './pages/StaffDashboard';
import PromocionCuponProvider from './components/PromocionCuponProvider';
import Planes from './pages/Planes';
import Pagos from './components/Pagos';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PropiedadesProvider } from './components/PropiedadesContext';
import { Toaster } from './components/ui/toaster';
import { GoogleAuthProvider } from './config/googleAuth';
import './App.css';
import { Contact } from 'lucide-react';

// Componente modificado para redirigir a usuarios staff solo en la ruta raíz
const StaffRedirect = () => {
  const { user } = useAuth();
  
  return null; // No hacemos ninguna redirección automática
};

const App = () => {
  return (
    <React.StrictMode>
    <AuthProvider>
      <ThemeProvider>
      <GoogleAuthProvider>
      <PropiedadesProvider>
      <PromocionCuponProvider>
        <Router>
        <ScrollToTop />
          <div className="app-container">
            {/* Componente para redirigir automáticamente a usuarios staff solo desde la página principal */}
            <StaffRedirect />
            
            {/* El header solo se muestra en rutas que no son de admin */}
            <Routes>
              <Route path="/admin/*" element={null} />
              <Route path="*" element={<Header />} />
            </Routes>
            
            <main className="main-content">
              <Routes>
                {/* Rutas principales */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/buscar" element={<SearchResults />} />
                <Route path="/mis_propiedades" element={<MyListings />} />
                <Route path="/publicar" element={<PropertySelection />} />
                <Route path="/publicar/:operationType" element={<Publish />} />
                <Route path="/historial" element={<HistorialPage />} />
                <Route path="/terminos" element={<Terminos />} />
                <Route path="/privacidad" element={<Privacidad />} />
                <Route path="/contacto" element={<Contacto />} />
                <Route path="/planes" element={<Planes />} />
                <Route path="/pagos" element={<Pagos />} />
                
                {/* Ruta para publicar proyectos usando el mismo componente Publish */}
                <Route path="/publicar/:operationType/:publicationType" element={<Publish />} />
                
                <Route path="/upgrade-plan" element={<UpgradeUser />} />
                <Route path="/upgrade-to-inmobiliaria" element={<UpgradeToInmobiliaria />} />
                <Route path="/upgrade-user" element={<UpgradeToSeller />} />
                <Route path="/favoritos" element={<Favorites />} />
                <Route path="/editar-propiedad/:propertyId" element={<EditPublish />} />
                <Route path="/editar-alquiler/:id" element={<EditRent />} />
                
                {/* Nueva ruta para editar proyectos */}
                <Route path="/editar-proyecto/:id" element={<EditProyect />} />
                
                <Route path="/edit-profile" element={<EditProfile />} />
                <Route path="/statistics" element={<Statistics />} />
                <Route path="/flyers/:id" element={<FlyerPage />} />
                <Route path="/statistics/:propertyId" element={<PropertyStatistics />} />
                <Route path="/allproperties" element={<AllProperties />} />
                
                {/* Rutas de propiedades - Asegúrate de que estén disponibles para todos los usuarios */}
                <Route path="/propiedad/:id" element={<PropertyDetail />} />
                <Route path="/alquiler/:id" element={<AlquilerDetail />} />
                <Route path="/proyecto/:id" element={<ProyectDetails />} />
                <Route path="/propiedades/:type" element={<PropertyTypePage />} />
                <Route path="/alquileres/:type" element={<AlquilerPage />} />
                
                {/* Nueva ruta para visualizar proyectos por tipo */}
                <Route path="/proyectos/:type" element={<PropertyTypePage />} />
                
                <Route path="/map" element={<PropertyMap />} />
                <Route path="/todos" element={<PropertyTypePage />} />
                <Route path="/configuracion" element={<Configuration />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/conspublish" element={<ConsPublish />} />
                <Route path="/inmstatistics" element={<InKayrosStatistics />} />
                
                {/* Rutas de registro */}
                <Route path="/register/cliente" element={<ClientRegister />} />
                <Route path="/register/vendedor" element={<SellerRegister />} />
                <Route path="/register/inmobiliaria" element={<InmRegister />} />

                {/* Rutas de usuarios */}
                <Route path="/usuarios" element={<UserTypePage />} />
                <Route path="/usuarios/all" element={<UserTypePage />} />
                <Route path="/usuarios/vendedores" element={<UserTypePage />} />
                <Route path="/usuarios/constructoras" element={<UserTypePage />} />
                <Route path="/usuarios/inmobiliarias" element={<UserTypePage />} />
                <Route path="/usuarios/:tipo" element={<UserTypePage />} />

                {/* Rutas de perfil */}
                <Route path="/mi_perfil" element={<ProfileRouter />} />
                <Route path="/vendedor/:nombre_usuario" element={<ProfileRouter />} />
                <Route path="/inmobiliaria/:nombre_usuario" element={<ProfileRouter />} />
                <Route path="/constructora/:nombre_usuario" element={<ProfileRouter />} />
                
                {/* Rutas para ver todas las propiedades de un perfil */}
                <Route path="/vendedor/:nombre_usuario/propiedades" element={<AllProperties />} />
                <Route path="/inmobiliaria/:nombre_usuario/propiedades" element={<AllProperties />} />
                <Route path="/constructora/:nombre_usuario/propiedades" element={<AllProperties />} />
                
                {/* Rutas para ver todos los proyectos de un perfil */}
                <Route path="/constructora/:nombre_usuario/proyectos" element={<AllProperties type="proyectos" />} />

                {/* Nuevas rutas para propiedades específicas de un usuario */}
                <Route path="/usuario/:id/propiedades" element={<AllProperties />} />
                <Route path="/propiedades/usuario/:id" element={<AllProperties />} />
                <Route path="/alquileres/usuario/:id" element={<AllProperties />} />
                <Route path="/proyectos/usuario/:id" element={<AllProperties type="proyectos" />} />

                {/* RUTAS PARA STAFF Y ADMINISTRACIÓN - Acceso directo pero StaffDashboard valida el tipo de usuario */}
                <Route path="/admin/register" element={<StaffRegister />} />
                <Route path="/admin/dashboard" element={<StaffDashboard />} />
                <Route path="/admin/users" element={<StaffDashboard selectedModule="users" />} />
                <Route path="/admin/properties" element={<StaffDashboard selectedModule="properties" />} />
                <Route path="/admin/reports" element={<StaffDashboard selectedModule="reports" />} />
                <Route path="/admin/statistics" element={<StaffDashboard selectedModule="stats" />} />
                <Route path="/admin/settings" element={<StaffDashboard selectedModule="settings" />} />
                
                {/* Ruta para redirigir cualquier otra ruta de admin al dashboard */}
                <Route path="/admin/*" element={<Navigate to="/admin/dashboard" replace />} />
                
                {/* Ruta falsa para confundir a usuarios no autorizados */}
                <Route path="/admln/*" element={<NotFound />} />
                
                {/* Ruta catch-all para páginas no encontradas */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            
            {/* El footer solo se muestra en rutas que no son de admin */}
            <Routes>
              <Route path="/admin/*" element={null} />
              <Route path="*" element={<Footer />} />
            </Routes>
            
            <Toaster />
            
            {/* CookieConsent solo se muestra en rutas que no son de admin */}
            <Routes>
              <Route path="/admin/*" element={null} />
              <Route path="*" element={<CookieConsent />} />
            </Routes>
          </div>
        </Router>
        </PromocionCuponProvider>
      </PropiedadesProvider>
      </GoogleAuthProvider>
      </ThemeProvider>
    </AuthProvider>
    </React.StrictMode>
  );
};

export default App;